var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticStyle:{"margin-bottom":"16px"},attrs:{"error-messages":_vm.localTimeError,"label":_vm.name,"outlined":"","dense":"","hide-details":"auto","disabled":typeof _vm.disabled !=='undefined'},model:{value:(_vm.localTime),callback:function ($$v) {_vm.localTime=$$v},expression:"localTime"}})
}
var staticRenderFns = []

export { render, staticRenderFns }